import { AxiosResponse } from "axios";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { getNFT, getUserNFTBalance, getUserNFTs, uploadNFTMetadata } from "../api";
import { NFTResponse, PinataUploadResponse } from "../types";

export function useUploadNFTMetadata() {
    const query = useMutation<AxiosResponse<any, PinataUploadResponse>, Error, FormData, any>(uploadNFTMetadata, {
        onError(error: any) {
            if (error.response.data) toast.error(error.response.data, { autoClose: 5000 })
            else if (error instanceof Error) toast.error(error.message, { autoClose: 5000 })
            else {
                toast.error('Errors while uploading metadata. Please check and try again.', { autoClose: 5000 })
            }
        },
        retry: false,
    });
    return query;
};

export function useGetNFTInfo(tokenId: string, enabled: boolean = true) {
    const query = useQuery<AxiosResponse<NFTResponse>, Error>(["nfts", tokenId], () => getNFT(tokenId), {
        onError(error: any) {
            if (error?.response?.data) toast.error(error.response.data, { autoClose: 5000 })
            else if (error instanceof Error) toast.error(error?.message, { autoClose: 5000 })
            else {
                toast.error('Errors while fetching NFT info. Please check and try again.', { autoClose: 5000 })
            }
            return error;
        },
        enabled: enabled && !!tokenId,
        retry: 3,
        refetchOnWindowFocus: false,
    })

    return query;
};

export function useGetNFTBalance(address: string, enabled: boolean = true) {
    const query = useQuery<AxiosResponse<string>, Error>(["nfts", "balance", address], () => getUserNFTBalance(address), {
        onError(error: any) {
            if (error?.response?.data) toast.error(error.response.data, { autoClose: 5000 })
            else if (error instanceof Error) toast.error(error?.message, { autoClose: 5000 })
            else {
                toast.error('Errors while fetching NFT balance. Please check and try again.', { autoClose: 5000 })
            }
            return error;
        },
        enabled: enabled && !!address,
        retry: 3,
        refetchOnWindowFocus: false,
    })

    return query;
};

export function useGetUserNFTs(address: string, enabled: boolean = true) {
    const query = useQuery<AxiosResponse<NFTResponse[]>, Error>(["nfts", "user", address], () => getUserNFTs(address), {
        onError(error: any) {
            if (error?.response?.data) toast.error(error.response.data, { autoClose: 5000 })
            else if (error instanceof Error) toast.error(error?.message, { autoClose: 5000 })
            else {
                toast.error('Errors while fetching user\'s NFTs. Please check and try again.', { autoClose: 5000 })
            }
            return error;
        },
        enabled: enabled && !!address,
        retry: 3,
        refetchOnWindowFocus: false,
    })

    return query;
};
